export default "__VITE_ASSET__ClqZr3vj__"